module.exports = __webpack_public_path__ + "static/wohngebaeude-351fb8137b09a01fdac0b640b86453f6.PNG";